import { useState } from 'react';

export const useForm = options => {
  const [data, setData] = useState(options?.initialValues || {});
  const [errors, setErrors] = useState({});

  const handleChange = (newData, sanitizeFn) => {
    Object.keys(newData).forEach(key => {
      const processedValue = sanitizeFn
        ? sanitizeFn(newData[key])
        : newData[key];
      newData[key] = processedValue;
    });
    setData({
      ...data,
      ...newData,
    });
  };

  const triggerValidation = () => {
    const validations = options?.validations;
    if (validations) {
      let valid = true;
      const newErrors = {};
      for (const key in validations) {
        const value = data[key];
        const validation = validations[key];
        if (validation?.required?.value && !value) {
          valid = false;
          newErrors[key] = validation?.required?.message;
          continue;
        }

        const pattern = validation?.pattern;
        if (pattern?.value && !RegExp(pattern.value).test(value)) {
          valid = false;
          newErrors[key] = pattern.message;
          continue;
        }

        const custom = validation?.custom;
        if (custom?.isValid && !custom.isValid(value)) {
          valid = false;
          newErrors[key] = custom.message;
        }
      }

      if (!valid) {
        setErrors(newErrors);
        return newErrors;
      }
    }

    setErrors({});
    return {};
  };

  return {
    data,
    handleChange,
    triggerValidation,
    errors,
  };
};
